import { useEffect } from 'react';
import { useScheduleStore, ScheduleInput } from '../lib/store/scheduleStore';
import { VacationDay } from '../types/schedule';

export const useSchedule = (scheduleId?: string) => {
  const {
    currentSchedule,
    isLoading,
    error,
    fetchSchedule,
    fetchShifts,
    fetchVacationDays,
    shifts,
    vacationDays
  } = useScheduleStore();

  useEffect(() => {
    if (scheduleId) {
      fetchSchedule(scheduleId);
      fetchShifts(scheduleId);
      fetchVacationDays(scheduleId);
    }
  }, [scheduleId, fetchSchedule, fetchShifts, fetchVacationDays]);

  return {
    schedule: currentSchedule,
    shifts,
    vacationDays,
    isLoading,
    error
  };
};

export const useTeamSchedules = (teamId?: string) => {
  const {
    teamSchedules,
    isLoadingTeamSchedules,
    error,
    fetchTeamSchedules
  } = useScheduleStore();

  useEffect(() => {
    if (teamId) {
      fetchTeamSchedules(teamId);
    }
  }, [teamId, fetchTeamSchedules]);

  return {
    schedules: teamSchedules,
    isLoading: isLoadingTeamSchedules,
    error
  };
};

export const useScheduleActions = () => {
  const {
    createSchedule,
    updateScheduleStatus,
    assignProviderToShift,
    addVacationDays,
    removeVacationDay,
    openForPreferences,
    closePreferences,
    publishSchedule,
    isLoading
  } = useScheduleStore();

  const createNewSchedule = async (schedule: ScheduleInput) => {
    return createSchedule(schedule);
  };

  const addVacation = async (scheduleId: string, vacationDays: VacationDay[]) => {
    return addVacationDays(scheduleId, vacationDays);
  };

  const removeVacation = async (scheduleId: string, vacationDay: VacationDay) => {
    return removeVacationDay(scheduleId, vacationDay);
  };

  const assignProvider = async (shiftId: string, providerId: string | null) => {
    return assignProviderToShift(shiftId, providerId);
  };

  const openScheduleForPreferences = async (scheduleId: string, dueDate: string) => {
    return openForPreferences(scheduleId, dueDate);
  };

  const closeSchedulePreferences = async (scheduleId: string) => {
    return closePreferences(scheduleId);
  };

  const publishScheduleToTeam = async (scheduleId: string) => {
    return publishSchedule(scheduleId);
  };

  return {
    createNewSchedule,
    updateScheduleStatus,
    assignProvider,
    addVacation,
    removeVacation,
    openScheduleForPreferences,
    closeSchedulePreferences,
    publishScheduleToTeam,
    isLoading
  };
}; 